/* eslint-disable */
import Backbone from 'backbone';
import App from './app';
import './src/scss/bcom/main.scss';


App.brand = 'bcom';


App.on('start', () => {
  if (Backbone.history && App.meta && App.meta.quickview) {
        import(/* webpackChunkName: 'qv-bcom' */ './src/js/bcom/quick-view-loader');
  }
});


export default App;
